// extracted by mini-css-extract-plugin
export default {"adminAuth":"UiDrawer_adminAuth__oG2AX","authDetails":"UiDrawer_authDetails__yr0NO","drawer":"UiDrawer_drawer__5IFCr"};